/**
 * Human-readable marker identifying holds caused by application rejection. Reopening may release
 * only a hold from that same rejection.
 * Keep this prefix and rejectHoldNote aligned with the backend automated-reviewer path; the free-
 * text note is the only channel that identifies the hold reason.
 */
export const REJECT_HOLD_NOTE_PREFIX = 'Rejected application';

/**
 * Build the note for a reject-time hold.
 *
 * @param applicationId the application being rejected
 * @param note the approver's free-text rejection feedback, if any
 */
export function rejectHoldNote(applicationId: string, note?: string | null) {
  const prefix = `${REJECT_HOLD_NOTE_PREFIX} ${applicationId}.`;
  const trimmed = note?.trim();

  return trimmed ? `${prefix} ${trimmed}` : prefix;
}

/**
 * Whether a participant hold note was written by rejecting the given application.
 *
 * Scoped to the application id on purpose: a participant may have been held by an
 * earlier rejection of a *different* application, and reopening this one must not
 * release that hold.
 */
export function isRejectHoldNoteFor(applicationId: string, note?: string | null) {
  return Boolean(note?.startsWith(`${REJECT_HOLD_NOTE_PREFIX} ${applicationId}.`));
}
